import { styled } from '@mui/material';
import React, { useMemo } from 'react';

import AreaSvgIcon from '../../../assets/svg/feature-list/AreaSvgIcon';
import Input from '../../../components/Input';
import { MainFeature } from '../../../types';

const Container = styled('div')`
  border: 1px solid #e5e5e5;
  padding: 16px;
  border-radius: 8px;
  color: black;
  & > .title {
    display: flex;
    align-items: center;
  }
  & > label {
    padding-top: 15px;
    color: var(--Secondary-60, #a1a1a1);
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  & .warning-message {
    color: #e6a600;
    font-size: 0.75rem;
  }
`;

const FEATURE_AREA_LIMITS: Record<MainFeature, number> = {
  light: 5,
  standard: 10,
  premium: 20,
  basic: 20,
  four_s: 20,
};

interface AreaLimitContentProps {
  areaLimit: number | undefined;
  mainFeatureType: MainFeature;
  onChange: (areaLimit: number) => void;
}

const AreaLimitContent: React.FC<AreaLimitContentProps> = ({
  areaLimit,
  mainFeatureType,
  onChange,
}) => {
  const max = useMemo(
    () => FEATURE_AREA_LIMITS[mainFeatureType] ?? Infinity,
    [mainFeatureType],
  );

  const validateAreaLimit = (value: number): string | undefined => {
    if (value < 0) {
      return '▲Warning:Area limit cannot be negative';
    }
    if (value > max) {
      return `▲Warning: Area limit exceed ${mainFeatureType} default limit of ${max}`;
    }
    return undefined;
  };

  const areaWarningMessage = validateAreaLimit(areaLimit ?? 0);

  return (
    <Container>
      <div className="title">
        <AreaSvgIcon />
        Area Limit
      </div>
      <label> Area Limit (max {isFinite(max) ? max : 'unlimited'})</label>
      <Input
        sx={{
          width: '100%',
          display: 'block',
          placeholderShown: 'true',
        }}
        value={areaLimit ?? ''}
        placeholder={`Default: ${max}`}
        min={0}
        max={max}
        type="number"
        onChange={(e) => {
          const value =
            e.target.value === '' ? undefined : Number(e.target.value);
          onChange(value ?? max);
        }}
      />
      <div className="warning-message">{areaWarningMessage}</div>
    </Container>
  );
};

export default AreaLimitContent;
